import * as React from 'react';

interface LabelProps {
  required?: boolean;
  children?: string; // React.ReactNode[] | React.ReactNode;
}

const Label = ({ required, children }: LabelProps) => {
  return (
    <label className="form-control-label">
      {children}: {required && <span className="tx-danger">*</span>}
    </label>
  );
};

export default Label;
